import * as React from "react";
import { ProductLayout } from "../../../models";

export interface LayoutCarouselItemProps extends ProductLayout {}

const LayoutCarouselItem = (props: LayoutCarouselItemProps) => (
  <div className="layout-carousel__item">
    <img
      className="img-responsive layout-carousel__thumbnail"
      src={props.image}
      alt={props.name}
      title={props.name}
    />
  </div>
);

export default LayoutCarouselItem;



// WEBPACK FOOTER //
// ./src/routes/WizardLayoutChoice/components/LayoutCarouselItem.tsx